export { computeStackTrace } from './computeStackTrace';
export { startUnhandledErrorCollection } from './tracekit';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/domain/tracekit/index.js
// module id = 132
// module chunks = 2